import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import { useReactFormController } from '@ninja/utilities';
import { useResponsiveView } from './useResponsiveView.js';
import { FormFieldErrors } from './FormFieldErrors2.js';
import { FormInputGroup } from './FormInputGroup2.js';
import classNames from './RadioCard3.js';
import { RadioCardItem } from './RadioCard4.js';

function RadioCard(props) {
    const { sm: isMobile } = useResponsiveView();
    const { cards, form, field, label, isRequired, popover, popoverVariant, description, onChange, layoutClassName, reserveLabelSpacing, direction, size, testId, } = props;
    const { onChange: onFormChange, value, hasErrors, errors, formId, } = useReactFormController(props);
    const isReactForm = form && field;
    const onClick = (card) => {
        const internalOnChange = isReactForm ? onFormChange : onChange;
        value === card.id ? internalOnChange === null || internalOnChange === void 0 ? void 0 : internalOnChange(undefined) : internalOnChange === null || internalOnChange === void 0 ? void 0 : internalOnChange(card.id);
    };
    const dir = direction ? direction : isMobile ? 'col' : 'row';
    const groupName = useId();
    return (jsxs(FormInputGroup, { label: label, isRequired: isRequired, popover: popover, popoverVariant: popoverVariant, layoutClassName: layoutClassName, reserveLabelSpacing: reserveLabelSpacing, formId: formId, hasErrors: hasErrors, children: [jsx("div", { className: classNames.container(dir), "data-testid": testId, children: cards.map((option) => (jsx(RadioCardItem, { option: option, groupName: groupName, hasErrors: hasErrors, onClick: onClick, value: value, size: size }, option.id))) }), errors ? (jsx(FormFieldErrors, { errors: errors })) : (description && jsx("p", { className: classNames.descriptionClassNames, children: description }))] }));
}

export { RadioCard };
